import(/* webpackMode: "eager", webpackExports: ["LegalLayout"] */ "/home/hannah/Documentos/Vorseum/vorseum_institucional/components/legal/LegalLayout.tsx");
